import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 20px;
`;

export const AgentHeader = styled.div`
  display: flex;
  flex-direction: column;
  & > div:first-child {
    display: flex;
    justify-content: space-between;
    & > h5 {
      margin: 0;
    }
    & > div {
      display: flex;
      gap: 16px;
    }
  }
`;

export const ListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 45px 0 12px 0;
  & > div {
    display: flex;
    gap: 16px;
  }
`;

export const IntentContainer = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: row;
`;

export const ChatWrapper = styled.div`
  width: 320px;
`;

export const IntentWrapper = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 0;
  flex: 1;
`;

export const IntentBlock = styled.div`
  width: 656px;
  & > h5 {
    color: ${props => props.theme.colors.gray6};
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
  & > div {
    padding: 24px;
    background-color: ${props => props.theme.colors.background.default};
    border-radius: 4px;
    border: 1px solid #ddd;
    & > p {
      font-size: 14px;
      font-weight: 600;
    }
  }
`;

export const IntentFieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const IntentField = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr;
  align-items: ${props => props.alignItems || 'center'};
  & > p {
    color: #000;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    margin: 0;
    display: flex;
    align-items: center;
    & > span {
      font-weight: 400;
    }
  }
  & > input {
    max-width: none;
  }
  & > .expandable-textarea-container > textarea {
    font-size: 14px;
    border-radius: 2px;
    padding: 8px 12px;
    border-color: ${props => props.theme.colors.gray1};
    resize: vertical;
    min-height: 80px;
    max-height: 250px;
  }
`;

export const ApprovalIntentBlock = styled.div`
  display: ${props => (props.show ? 'grid' : 'none')};
`;

export const ApprovalIntentWrapper = styled.div``;

export const ApprovalIntentField = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  & > p {
    color: #000;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    margin: 0;
  }
  & > input {
    max-width: none;
  }
`;

export const ApprovalContactTypeSelectWrapper = styled.div`
  flex-grow: 1;
  margin-left: 40px;
`;

export const ApprovalIntentContactTypes = styled.div`
  display: ${props => (props.show ? 'flex' : 'none')};
  margin-top: 20px;
`;

export const IntentArgumentWrapper = styled.div`
  border-radius: 4px;
  border: 1px solid #ddd;
  padding: 10px 20px 20px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.colors.background.default};
`;

export const IntentArgumentActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  button {
    background-color: transparent;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    height: 28px;
    width: 28px;
    svg {
      color: ${props => props.theme.colors.gray5};
    }
    :last-child svg {
      color: ${props => props.theme.colors.red1};
    }
    :hover,
    :active {
      background-color: ${props => props.theme.colors.border.default};
    }
  }
`;

export const IntentArgumentTypeContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  & > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    width: 100%;
    margin-bottom: 12px;
    & > input {
      max-width: none;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100%;
`;

export const Body = styled.div`
  flex-grow: 1;
  padding: 20px;
  box-shadow: 0px 14px 50px rgba(0, 0, 0, 0.1);
  z-index: 2;
`;

export const Aside = styled.div`
  width: 423px;
  max-height: 700px;
  z-index: 1;
  position: sticky;
  top: 120px;
  flex-shrink: 0;
  padding: 10px;
  label {
    margin: 0;
  }
`;

export const AgentSettingsBox = styled.div`
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #ddd;
`;

export const AgentSettingsBoxHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  h6 {
    font-size: 16px;
    margin: 0;
    font-weight: 600;
  }
  p {
    font-size: 14px;
    margin: 6px 0 0 0;
    color: ${props => props.theme.colors.gray6};
  }
`;

export const AgentSettingsBoxContent = styled.div`
  & > div {
    &:not(:last-child) {
      margin-bottom: 24px;
    }
    & > p {
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 10px;
    }
    & > label {
      margin-bottom: 16px;
      font-size: 14px;
    }
    textarea {
      font-size: 14px;
    }
  }
`;

export const DeactivationTimeoutWrapper = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  input {
    margin: 0 10px;
    height: 34px;
    width: 60px;
    padding-left: 6px;
    padding-right: 6px;
    text-align: center;
    -moz-appearance: textfield;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`;

export const SettingsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
